module.exports = {"411729001":"古吕街道","411729002":"今是街道","411729003":"月亮湾街道","411729101":"砖店镇","411729102":"陈店镇","411729103":"佛阁寺镇","411729104":"练村镇","411729105":"棠村镇","411729106":"韩集镇","411729107":"龙口镇","411729108":"李桥回族镇","411729109":"黄楼镇","411729110":"孙召镇","411729111":"余店镇","411729204":"河坞乡","411729205":"关津乡","411729206":"宋岗乡","411729207":"顿岗乡","411729208":"涧头乡","411729209":"杨庄户乡","411729210":"化庄乡","411729211":"栎城乡","411729213":"弥陀寺乡","411729400":"南湖街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411729.json
// module id = 1818
// module chunks = 0